import { api } from '../axios'
import type { ApiResponse, FinancialTransaction } from '@/types'
import type {
  GetTransactionsParams,
  GetTransactionsResponse,
  CreateTransactionData,
  UpdateTransactionData,
  GetFinancialSummaryParams,
  FinancialSummaryResponse,
} from './financial.static'

export const financialService = {
  async getTransactions(params?: GetTransactionsParams): Promise<GetTransactionsResponse> {
    const response = await api.get<ApiResponse<GetTransactionsResponse>>('/financials', { params })
    return response.data.data
  },

  async getTransaction(id: string): Promise<FinancialTransaction> {
    const response = await api.get<ApiResponse<FinancialTransaction>>(`/financials/${id}`)
    return response.data.data
  },

  async createTransaction(data: CreateTransactionData): Promise<FinancialTransaction> {
    const response = await api.post<ApiResponse<FinancialTransaction>>('/financials', data)
    return response.data.data
  },

  async updateTransaction(id: string, data: UpdateTransactionData): Promise<FinancialTransaction> {
    const response = await api.patch<ApiResponse<FinancialTransaction>>(`/financials/${id}`, data)
    return response.data.data
  },

  async deleteTransaction(id: string): Promise<void> {
    await api.delete(`/financials/${id}`)
  },

  async getSummary(params?: GetFinancialSummaryParams): Promise<FinancialSummaryResponse> {
    const response = await api.get<ApiResponse<FinancialSummaryResponse>>('/financials/summary', {
      params,
    })
    return response.data.data
  },
}
